import { useMemo } from 'react'
import { useFetchUserStatusQuery } from '@/api/user-api'
import {
  BasicService,
  PredictiveReportService,
  ServiceCategory,
} from '@/types/mock-api-types'
import { Optional } from '@/types/optional'

type UsePredictiveReportLimit = () => PredictiveReportService['memo']

const usePredictiveReportLimit: UsePredictiveReportLimit = () => {
  const { data: userStatus } = useFetchUserStatusQuery()

  const isPredictiveReportService = (
    service?: BasicService,
  ): service is PredictiveReportService =>
    service?.serviceCategory === ServiceCategory.PredictiveReport

  const findPredictiveReportService = (): Optional<PredictiveReportService> =>
    userStatus?.currentWorkspace.availableServices.find(
      isPredictiveReportService,
    )

  const predictiveReportService = findPredictiveReportService()

  return useMemo(() => {
    return {
      predictiveReportLimit:
        predictiveReportService?.memo.predictiveReportLimit ?? 0,
      predictiveReportCollaborativeItemsLimit:
        predictiveReportService?.memo.predictiveReportCollaborativeItemsLimit ??
        0,
    }
  }, [predictiveReportService])
}

export default usePredictiveReportLimit
